import { SerializeContext } from "abweb/utils/json/SerializeContext";
import "@abinitio/kendo.all";

// Deliberately does NOT extend KendoObservableObjectProxyBase so that it can be an ObservableObject
export class KendoObservableObjectProxy extends kendo.data.ObservableObject {
  // Essentially replace body of KOOP with KOOPBase, with two minor enhancements:
  // 1. class line extends from kendo.data.OO and implements I{De}Serialize
  // 2. constructor invokes super() as extends kendo.data.ObservableObject

  /** Do NOT invoke directly, instead use strongly typed createKendoObservableObjectProxyBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "com.abinitio.webcommons.abweb.dto.kendo.KendoObservableObjectProxy";
  }
  initFromJson(json, deserializeContext) {
    this.initKendoObservableObjectProxy();
  }
  initKendoObservableObjectProxy() {}
  toTSOG(result, serializeContext) {
    const retVal = result;
    return retVal;
  }
  toJSON() {
    // PJM: I have seen cases where Kendo is calling toJSON() which can cause stack overflow since toJSON() cannot deal with circular refs.
    // I think calling into toTSOG() will be a bit better here.
    return this.toTSOG({}, new SerializeContext());
  }
}
//# sourceMappingURL=KendoObservableObjectProxy.js.map
